const mixins = {
  toolbar: {
    minHeight: 56,
    "@media (min-width:600px)": {
      minHeight: 64,
    },
    "@media (min-width:0px) and (orientation: landscape)": {
      minHeight: 56,
    },
  },
};

export default mixins;
